<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData" :inline-message="true" class="demo-ruleForm"> <!--:rules="rules" -->
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}B端用户
        </div>
        <div class="fr">
          <el-button v-if="business_edit" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存
          </el-button>
        </div>
      </div>
      <div>

        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  档案号
                </th>
                <td>{{ formData.profileNo }}</td>
                <th>
                  <em class="f-red">*</em>姓名
                </th>
                <td> <!--@blur="inspection"-->
                  <el-input type="text" autocomplete="off" v-model="formData.userName" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>手机号码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="userMobiles" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>用户身份
                </th>
                <td>
                  <el-select v-model="formData.userType">
                    <el-option :value="1" label="导购"></el-option>
                    <el-option :value="2" label="工程师"></el-option>
                    <el-option :value="3" label="信息员"></el-option>
                    <el-option :value="4" label="店铺客服"></el-option>
                    <el-option :value="9" label="其他"></el-option>
                  </el-select>
                </td>
                <th>
                  购买店铺
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.shopName" clearable/>
                </td>

              </tr>
              <tr>
                <th>
                  服务商
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.siteName" readonly clearable>
                    <i slot="suffix" class="el-input__icon el-icon-search"
                      @click="showPreconditionDialog = true"></i>
                  </el-input>
                </td>
                <th>
                  电商平台
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.platform" clearable/>
                </td>
                <th>
                  创建方式
                </th>
                <td>
                  <el-select v-model="formData.createType">
                    <el-option :value="1" label="DMS"></el-option>
                    <el-option :value="2" label="手工维护"></el-option>
                    <el-option :value="3" label="呼叫中心"></el-option>
                  </el-select>
                </td>
                <th>
                  信息来源
                </th>
                <td>
                  <el-select v-model="formData.userSource">
                    <el-option :value="1" label="DMS"></el-option>
                    <el-option :value="2" label="手工维护"></el-option>
                    <el-option :value="3" label="呼叫中心"></el-option>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>是否启用
                </th>
                <td>
                  <el-select v-model="formData.isEnable">
                    <el-option :value="0" label="否"></el-option>
                    <el-option :value="1" label="是"></el-option>
                  </el-select>
                </td>
              </tr>
              <!-- <tr>
                <th>
                  经销商名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.oneDealerName" clearable/>
                </td>
                <th>
                  二级经销商
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.twoDealerName" clearable/>
                </td>
                <th>
                  联系人
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.cellMobile" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>是否启用</th>
                <td>
                  <el-select v-model="formData.isEnable">
                    <el-option :value="0" label="禁用"></el-option>
                    <el-option :value="1" label="启用"></el-option>
                  </el-select>
                </td>
              </tr> -->
              <tr>
                <th>地区</th>
                <td colspan="3">
                  <el-cascader :props="areaProps" v-model="areaValues" :clearable="true"
                              @change="handleChange" ref="cascaderAddr"
                              style="width: 100%"
                              :options="areaOption">
                  </el-cascader>
                </td>
                <th>
                  详细地址
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.address" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>报单量
                </th>
                <td>
                  <el-input type="number" autocomplete="off" v-model="formData.orderQty" clearable/>
                </td>
                <th>
                  有无档案
                </th>
                <td>
                  <el-select v-model="formData.isProfile" :disabled="true">
                    <el-option :value="0" label="否"></el-option>
                    <el-option :value="1" label="是"></el-option>
                  </el-select>
                </td>
              </tr>
              <!-- <tr>
                <th>产品陈列照</th>
                <td colspan="">
                  <div>
                  <photoUpload :photo-url.sync="formData.itemPic"/>

                  </div>
                </td>
                <th>店面照</th>
                <td colspan="">
                  <div>
                    <photoUpload :photo-url.sync="formData.storePic"/>

                  </div>
                </td>
                <th>门头照</th>
                <td colspan="">
                  <div>
                    <photoUpload :photo-url.sync="formData.doorPic"/>

                  </div>
                </td>
              </tr> -->
              <tr>
                <th>
                  是否废弃
                </th>
                <td>
                  <el-select v-model="formData.isDiscard" :disabled="true">
                    <el-option :value="0" label="否"></el-option>
                    <el-option :value="1" label="是"></el-option>
                  </el-select>
                </td>
                <th>
                  创建人
                </th>
                <td>{{ formData.createBy }}</td>
                <th>
                  创建时间
                </th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- <div class="d-item">
            <div class="title first">
              <b>补充信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  店铺说明
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.shopDesc" clearable/>
                </td>

                <th>
                  店长
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.shopManager" clearable/>
                </td>

                <th>
                  联系方式
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.shopPhone" clearable/>
                </td>
                <th>
                  指定服务商
                </th>
                <td>
                  <el-input style="width: 165px;" type="text" autocomplete="off" clearable v-model="formData.siteName"
                            :readonly="true">
                    <i slot="suffix" style="margin-top: 0" class="el-input__icon el-icon-search"
                       @click="showPreconditionDialog = true"></i>
                  </el-input>
                </td>
              </tr>
              <tr>

                <th>省/市/区/镇</th>
                <td colspan="3">
                  <el-cascader :props="areaProps" v-model="areaValues" :clearable="true"
                               @change="handleChange" ref="cascaderAddr"
                               style="width: 100%"
                               :options="areaOption">
                  </el-cascader>
                </td>

                <th>
                  详细地址
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.address" clearable/>
                </td>
              </tr>
              </tbody>
            </table>
          </div> -->
          <div>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 服务商 -->
    <preconditionDialog v-if="showPreconditionDialog" @commit="commitSelectedRow" :visiable.sync="showPreconditionDialog" multi="true" />

  </div>
</template>
<script>
// import request from "@/router/axios";
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";
import api from "@/api/projectApi";
import preconditionDialog from '@/views/dialogCommon/radioSiteDialog.vue';

// 图片
import photoUpload from "@/components/formItem/photoUpload.vue"

export default {
  mixins: [editPageMixins],
  name: 'storesEdit',
  props: {
    _dataId: [String, Number],
    initTableList: {
      type: Function,
      default: null
    }
  },
  components: {photoUpload,preconditionDialog},
  data() {
    return {
      business_edit: false,
      showPreconditionDialog: false,
      formData: {
        userName: '',
        userMobile: '',
        userType: '',
        shopName: '',
        isEnable: 1,
        isDiscard: 0,
        userSource: '',
        createType: '',
        siteId: '',
        siteName: '',
        profileNo: '',
        areaId: '',
        province: '',  // 省
        city: '',  // 市
        county: '',  // 区
        town: '',  // 镇
        address: '',  // 详细地址

      },
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      areaOption: [],
      areaValues: null,
      dictList:[],
      userMobiles:'',

      // buyChannelOptions: [],

      // tenant: {
      //   id: null,
      //   orderTypeName: null,
      //   isShowwx: 0,
      //   isShowIssue: 1,
      //   isShowSiteIssue: 0,
      //   code: null,
      //   seq: 0
      // },

      // rules: {
      //   orderTypeName: [{required: true, prop: '来源名称', type: 'string', maxlength: 20}],
      //   code: [{required: false, prop: '编码', type: 'string', maxlength: 10}]
      // },

      activeName: 'first',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    // 联系方式验证
    userMobiles: {
      handler(newVal, oldVal) {
        // console.log(newVal,"新值");
        this.formData.userMobile = newVal
        var numReg = /^[0-9]+$/
        var numRe = new RegExp(numReg)
        if (!numRe.test(this.formData.userMobile)) {
          // this.$message.error("请输入正确的11位手机号码");
        } else if (this.formData.userMobile.length > 11) {
          this.$message.error("手机号码不能超过11位");
          this.formData.userMobile = this.formData.userMobile.slice(0, 11);
          this.userMobiles = this.formData.userMobile
        }
      },
      deep: true, // 加这个属性，深度监听
    },
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.business_edit = this.permissions['business_edit']
  },
  mounted() {
    this.getData();
    // this.getDict();
    // this.loadBuyChannelOption();
    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {

    // getDict(){
    //   this.$http.post("/basic/basBuyShop/getDictItem")
    //     .then(response =>{
    //       this.dictList = response.data.data;
    //       this.dictList.forEach(item=>{
    //         console.log(item.label,item.id)
    //       })
    //     })
    // },

    // inspection() {
    //   if (this.formData.shopCode) {
    //     this.$http.post(api.basBuyShop.inspectionUrl, {
    //       value: this.formData.shopCode,
    //       id: this.formData.id,
    //     }).then(res => {
    //       if (!res.data.data) {
    //         this.$message.error("编码已存在，请重新输入")
    //         this.formData.shopCode = null
    //       }
    //     })
    //   }
    // },

    commitSelectedRow(data) {
      this.formData.siteId = data.id;
      this.formData.siteName = data.name;
    },

    // 加载购买渠道
    // loadBuyChannelOption() {
    //   this.$http({
    //     url: '/basic/basBuyChannel/getList',
    //     method: 'post',
    //     data: {
    //       buyChannelName: null
    //     }
    //   }).then(res => {
    //     this.buyChannelOptions = []
    //     res.data.data.forEach(item => {
    //       this.buyChannelOptions.push({
    //         label: item.buyChannelName,
    //         value: item.id
    //       })
    //     })
    //   })
    // },

    // 地址三级联动
    handleChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        this.formData.areaId = areaNode.value;
        if (areaNode[0].level == 1) {
          this.formData.province = areaNode[0].label;
          this.formData.city = null;
          this.formData.county = null;
          this.formData.town = null;
        } else if (areaNode[0].level == 2) {
          this.formData.city = areaNode[0].label;
          // this.formData.city = null;
          this.formData.county = null;
          this.formData.town = null;
        } else if (areaNode[0].level == 3) {
          this.formData.county = areaNode[0].label;
          // this.formData.county = null;
          this.formData.town = null;
        } else if (areaNode[0].level == 4) {
          this.formData.town = areaNode[0].label;
          // this.formData.town = null;
        } else if (areaNode[0].level == 5) {
          this.formData.town = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value;
      } else {
        this.formData.province = null;
        this.formData.city = null;
        this.formData.county = null;
        this.formData.town = null;
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId && this.formData.areaId != 0) {
        this.$http
          .post(api.basArea.echoAddressUrl, { id: this.formData.areaId })
          .then((res) => {
            console.log(res);
            this.areaOption = res.data.data.options;
            this.areaValues = res.data.data.values;
            this.area = res.data.data.names;
          });
      }
    },

    // 地址数据回显
    // echoAddress() {
    //   if (this.formData.province) {
    //     let areaNamePath = this.formData.province + '/'
    //     if (this.formData.city) {
    //       areaNamePath = areaNamePath + this.formData.city + '/'
    //     }

    //     if (this.formData.county) {
    //       areaNamePath = areaNamePath + this.formData.county + '/'
    //     }

    //     if (this.formData.town) {
    //       areaNamePath = areaNamePath + this.formData.town
    //     }

    //     this.$http.post(api.basArea.getAreaOptionByAreaNamePathUrl, {areaNamePath: areaNamePath}).then(res => {
    //       this.areaOption = res.data.data.options
    //       this.areaValues = res.data.data.values
    //       this.area = res.data.data.names
    //     })
    //   }
    // },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http.post(api.snBusinessUser.getDataUrl, {id: this.dataId}).then(res => {
          this.formData = res.data.data
          this.userMobiles = this.formData.userMobile
          this.echoAddress()
        })
      }
    },

    saveData() {
      if (this.formData.userMobile.length > 11) {
          this.$message.error("手机号码不能超过11位");
          this.formData.userMobile = this.formData.userMobile.slice(0, 11);
        }
      if (this.formData.userName == null || this.formData.userName == '') {
        this.$message.error("姓名不能为空！")
        return;
      }
      if (this.formData.userMobile == null || this.formData.userMobile == '') {
          this.$message.error("手机号码不能为空！")
          return;
      }
      if (this.formData.userType == null || this.formData.userType == '') {
        this.$message.error("用户身份不能为空！")
        return;
      }
      if (this.formData.orderQty == null || this.formData.orderQty == '') {
        this.$message.error("报单量不能为空！")
        return;
      }
      // if (this.formData.isEnable == null || this.formData.isEnable == '') {
      //   this.$message.error("是否启用不能为空！")
      //   return;
      // }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()
            var url = (this.isEdit ? api.snBusinessUser.businessUpdateUrl : api.snBusinessUser.businessAddUrl);
            this.$http({
              url: url,
              method: 'post',
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.$emit('goBackIndex')
              this.$mask.close()
            }).catch((res) => {
                console.log(res,"res999");
                this.$message.error("保存失败！");
                this.$mask.close()
              });
          });
        }
      });
    },

    // saveData() {
    //   const rules = {
    //     // shopType: [{prop: '类型', required: true, type: 'number', max: 99, }],
    //     shopCode: [{prop: '编码', required: true, type: 'string', maxlength: 20, }],
    //     shopName: [{prop: '名称', required: true, type: 'string', maxlength: 40, }],
    //     stat: [{prop: '状态', required: true, type: 'number', max: 99, }],
    //     shopDesc: [{prop: '店铺说明', required: false, type: 'string', maxlength: 40, }],
    //     shopManager: [{prop: '店长', required: false, type: 'string', maxlength: 20, }],
    //     shopPhone: [{prop: '联系方式', required: false, type: 'string', maxlength: 20, }],
    //   }

    //   this.dictList.forEach(item=>{
    //     if(item.id == this.formData.shopType){
    //       this.formData.shopTypeName = item.label
    //     }
    //   })
    //   this.$validate(this.formData, rules).then(() => {
    //     this.$baseConfirm('您确定要保存吗？').then(() => {
    //       this.$mask.open()
    //       let url = (this.formData.id != null ? api.basBuyShop.updateDataUrl : api.basBuyShop.addDataUrl);
    //       this.$http.post(url, this.formData).then(res => {
    //         this.$message.success("保存成功！");
    //         this.goBackIndex()
    //         this.$mask.close()
    //       }).catch(() => {
    //         this.$message.error("保存失败！");
    //         this.$mask.close()
    //       })
    //     })
    //   })
    // },

  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

</style>
